module.exports = __webpack_public_path__ + "static/media/empty-state-background-2.7e18a81c.png";